import {
  IoSettings,
  IoBag,
  IoClipboard,
  IoCube,
  IoSearch,
  IoCalculator,
  IoCash,
  IoDocumentText,
  IoSwapHorizontal,
  IoFolder,
  IoLink,
  IoPeople,
  IoChatbubbles,
  IoPricetag,
  IoTrophy,
  IoCar,
  IoGrid,
  IoCart,
  IoBarChart,
  IoWallet,
  IoReceipt,
  IoLayers,
  IoCard,
  IoConstruct,
  IoStorefront,
  IoStatsChart,
  IoList,
  IoArchive,
  IoAlbums,
  IoReader,
} from 'react-icons/io5';

const ICON_MAP = {
  'ion-settings': IoSettings,
  'ion-bag': IoBag,
  'ion-clipboard': IoClipboard,
  'ion-ios-box': IoCube,
  'ion-search': IoSearch,
  'ion-calculator': IoCalculator,
  'ion-social-usd': IoCash,
  'ion-document-text': IoDocumentText,
  'ion-arrow-swap': IoSwapHorizontal,
  'ion-folder': IoFolder,
  'ion-link': IoLink,
  'ion-ios-people': IoPeople,
  'ion-ios-chatbubbles': IoChatbubbles,
  'ion-ios-paper': IoPricetag,
  'ion-trophy': IoTrophy,
  'ion-android-car': IoCar,
  'ion-grid': IoGrid,
  'ion-cart': IoCart,
  'ion-stats-bars': IoBarChart,
  'ion-cash': IoWallet,
  'ion-ios-list': IoList,
  'ion-archive': IoArchive,
  'ion-ios-albums': IoAlbums,
  'ion-card': IoCard,
  'ion-ios-construct': IoConstruct,
  'ion-ios-analytics': IoStatsChart,
  'ion-receipt': IoReceipt,
  'ion-layers': IoLayers,
  'ion-storefront': IoStorefront,
  'ion-reader': IoReader,
};

export const getIcon = (ionClass) => ICON_MAP[ionClass] || IoGrid;
